import { ReactNode } from 'react';

interface LazyLoadProps {
  children?: ReactNode;
}

export const LazyLoad = ({ children }: LazyLoadProps) => <>{children}</>;
